import * as tslib_1 from "tslib";
import { FieldType } from '@ngx-formly/core';
var FormlyBooleanChooserComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FormlyBooleanChooserComponent, _super);
    function FormlyBooleanChooserComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyBooleanChooserComponent;
}(FieldType));
export { FormlyBooleanChooserComponent };
